import React from "react";

export enum ButtonSizes {
  icon = "icon",
  tiny = "tiny",
  small = "small",
  medium = "medium",
  large = "large",
}

export enum ButtonTypes {
  cta = "cta",
  ok = "ok",
  del = "delete",
  cancel = "cancel",
  neutral = "neutral",
}

export enum LabelColors {
  light = "#fafafa",
  dark = "#444444",
}

export interface ButtonProps {
  label: React.ReactNode;
  onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  size?: ButtonSizes;
  type?: ButtonTypes;
  primary?: boolean;
  disabled?: boolean;
  selected?: boolean;
  loading?: boolean;
  btnColor?: string;
  labelColor?: LabelColors;
}
